/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello.",
  title2: "Saqib Ali",
  logo_name: "Saqib",
  nickname: "Saqib / Ali",
  full_name: "Saqib Ali",
  subTitle:
    "A Full Stack Developer. I Loves Learning & Getting Better Every Day.",

  //resume link
  resumeLink:
    "https://drive.google.com/file/d/1LaqsOqlqkv3BLMtgyNzkGFr_hm7vziXw/view?usp=sharing",
  // "https://drive.google.com/file/d/150ekTuVFTs3i6qlnYozWfBrJLUDdmMLX/view?usp=sharing",
  mail: "mailto:saqibali046@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */

  github: "https://github.com/SaqibAli01",
  linkedin: "https://www.linkedin.com/in/saqib-ali-873803229/",
  gmail: "saqibali046@gmail.com",
  gitlab: "",
  facebook: "https://www.facebook.com/profile.php?id=100005100048524",
  twitter: "https://twitter.com/AliSaqibali046",
  instagram: "https://instagram.com/saqibali046?igshid=ODhra2MxejJoM292",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React Js.",
        "⚡ Building responsive website front end using Next js.",
        "⚡ Creating application backend in Node, Express & Mongo DB.",
        "⚡ Creating application backend in Firebase.",
        // "⚡I use Git, GitHub, Postman, Redux, Axios as my development tools.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "SASS",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#6D11EE",
          },
        },

        {
          skillName: "MUI",
          fontAwesomeClassname: "simple-icons:mui",
          style: {
            color: "#007FFF",
          },
        },

        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#3178C6",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#FFFFFF",
            backgroundColor: "#1D1D1D",
            borderRadius: "50%",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:nodedotjs",
          style: {
            color: "#61B348",
          },
        },
        {
          skillName: "ExpressJS",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#868686",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },

        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFA714",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },

        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#DE33A6",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },

        {
          skillName: "JSON",
          fontAwesomeClassname: "simple-icons:json",
          style: {
            color: "#29B0EE",
          },
        },

        {
          skillName: "ReduxJS",
          fontAwesomeClassname: "simple-icons:redux",
          style: {
            color: "#593D88",
          },
        },

        {
          skillName: "Stripe API",
          fontAwesomeClassname: "simple-icons:stripe",
          style: {
            color: "#69B6E3",
          },
        },
        {
          skillName: "PostMenApi",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FE6B36",
          },
        },

        {
          skillName: "Github",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#E94E32",
            // backgroundColor: "#fff",
          },
        },

        // {
        //   skillName: "MySQL",
        //   fontAwesomeClassname: "simple-icons:mysql",
        //   style: {
        //     color: "#E94E32",
        //   },
        // },

        // {
        //   skillName: "Java",
        //   fontAwesomeClassname: "simple-icons:java",
        //   style: {
        //     color: "#f89820",
        //   },
        // },
        // {
        //   skillName: "Kotlin",
        //   fontAwesomeClassname: "simple-icons:kotlin",
        //   style: {
        //     color: "#5c79df",
        //   },
        // },
        // {
        //   skillName: "Dart",
        //   fontAwesomeClassname: "simple-icons:dart",
        //   style: {
        //     color: "#29B0EE",
        //   },
        // },
        // {
        //   skillName: "Go",
        //   fontAwesomeClassname: "simple-icons:go",
        //   style: {
        //     color: "#00A7D0",
        //   },
        // },
        // {
        //   skillName: "Visual Basic",
        //   fontAwesomeClassname: "simple-icons:dot-net",
        //   style: {
        //     color: "#029FCE",
        //   },
        // },
        // {
        //   skillName: "C#",
        //   fontAwesomeClassname: "simple-icons:csharp",
        //   style: {
        //     backgroundColor: "transparent",
        //     color: "#3776AB",
        //   },
        // },

        // {
        //   skillName: "Android App Development",
        //   fontAwesomeClassname: "simple-icons:android",
        //   style: {
        //     color: "#3DDC84",
        //   },
        // },
        // {
        //   skillName: "Flutter",
        //   fontAwesomeClassname: "simple-icons:flutter",
        //   style: {
        //     color: "#02569B",
        //   },
        // },

        // {
        //   skillName: "Wordpress",
        //   fontAwesomeClassname: "simple-icons:wordpress",
        //   style: {
        //     color: "#207297",
        //   },
        // },
      ],
    },

    {
      title: "Front-end Skills",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Skills in responsive web design with HTML5, CSS3, and Sass.",
        "⚡ Libraries & Tools: Git, GitHub, Bootstrap, Material-UI for interfaces",
        // "⚡ Experience with Bootstrap & MUI for mobile-friendly interfaces.",
        "⚡ I've deployed on Surge, Vercel, Netlify, and Railway Cloud.",
        "⚡ Redux & RTK & RTK Query for seamless state management.",
        "⚡ Skilled in React.js and Next.js expert for dynamic web apps.",
        "⚡ Skills in  problem solve, debugging & fixing errors on websites.",
        // "⚡ Experience hosting and managing web apps on GCP and AWS",
        // "⚡ Deploying deep learning models on cloud to use on mobile devices",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "SASS",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#6D11EE",
          },
        },

        {
          skillName: "MUI",
          fontAwesomeClassname: "simple-icons:mui",
          style: {
            color: "#007FFF",
          },
        },

        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#3178C6",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#FFFFFF",
            backgroundColor: "#1D1D1D",
            borderRadius: "50%",
          },
        },

        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#DE33A6",
          },
        },
        {
          skillName: "ReduxJS",
          fontAwesomeClassname: "simple-icons:redux",
          style: {
            color: "#593D88",
          },
        },

        //----------------------------------------------------------------
        // {
        //   skillName: "GCP",
        //   fontAwesomeClassname: "simple-icons:googlecloud",
        //   style: {
        //     color: "#4285F4",
        //   },
        // },
        // {
        //   skillName: "AWS",
        //   fontAwesomeClassname: "simple-icons:amazonaws",
        //   style: {
        //     color: "#FF9900",
        //   },
        // },
        // {
        //   skillName: "Netlify",
        //   fontAwesomeClassname: "simple-icons:netlify",
        //   style: {
        //     color: "#38AFBB",
        //   },
        // },
        // {
        //   skillName: "Heroku",
        //   fontAwesomeClassname: "simple-icons:heroku",
        //   style: {
        //     color: "#6863A6",
        //   },
        // },
        // {
        //   skillName: "Firebase",
        //   fontAwesomeClassname: "simple-icons:firebase",
        //   style: {
        //     color: "#FFCA28",
        //   },
        // },
        // {
        //   skillName: "MongoDB",
        //   fontAwesomeClassname: "simple-icons:mongodb",
        //   style: {
        //     color: "#47A248",
        //   },
        // },
        // {
        //   skillName: "Docker",
        //   fontAwesomeClassname: "simple-icons:docker",
        //   style: {
        //     color: "#1488C6",
        //   },
        // },
      ],
    },
    {
      title: "Back-end Skills",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Skilled in Node.js and Express.js for backend development.",
        "⚡ Skilled in MongoDB for database management & Socket.IO.",
        "⚡ Familiar with Firebase for backend services.",
        "⚡ Tools and Third-Party Services : ",
        "⚡ Proficient with Postman API for API testing and debugging.",
        "⚡ Experienced in using the Stripe API for payment processing.",
        "⚡ Proficient in deploying applications on Vercel and Railway for hosting.",
      ],
      softwareSkills: [
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:nodedotjs",
          style: {
            color: "#61B348",
          },
        },
        {
          skillName: "ExpressJS",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#868686",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },

        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFA714",
          },
        },
        {
          skillName: "Stripe API",
          fontAwesomeClassname: "simple-icons:stripe",
          style: {
            color: "#69B6E3",
          },
        },
        {
          skillName: "PostMenApi",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FE6B36",
          },
        },
        //----------------------------------------------------------------
        // {
        //   skillName: "Tensorflow",
        //   fontAwesomeClassname: "logos-tensorflow",
        //   style: {
        //     backgroundColor: "transparent",
        //   },
        // },
        // {
        //   skillName: "Keras",
        //   fontAwesomeClassname: "simple-icons:keras",
        //   style: {
        //     backgroundColor: "white",
        //     color: "#D00000",
        //   },
        // },
        // {
        //   skillName: "PyTorch",
        //   fontAwesomeClassname: "logos-pytorch",
        //   style: {
        //     backgroundColor: "transparent",
        //   },
        // },
        // {
        //   skillName: "Python",
        //   fontAwesomeClassname: "ion-logo-python",
        //   style: {
        //     backgroundColor: "transparent",
        //     color: "#3776AB",
        //   },
        // },
        // {
        //   skillName: "Pandas",
        //   fontAwesomeClassname: "simple-icons:pandas",
        //   style: {
        //     backgroundColor: "transparent",
        //     color: "#6E6E6E",
        //   },
        // },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Government College University Faisalabad",
      subtitle: "BS Computer Science",
      logo_path: "dal.png",
      alt_name: "degrees",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ 2016 - 2020, I have done BSCS (Bachelor of Science in Computer Science).",
        "⚡ I have obtained CGPA (3.05) from total CGPA (4.00) and got 1 st Division.",
        "⚡ Studied  Programming languages and software development methodologies.",
        "⚡ Also studied Computer architecture & operating systems and networking & database systems",
        "⚡ I have studied core subjects like Data Structures, Software Engineering, DBMS, OOP etc.",
        // "⚡ Learn Advanced Topics in Cloud Computing, Cloud Architecture along with Serverless Computing",
        // "⚡ Worked on projects on courses like Mobile Computing and Web Technologies.",
      ],
      website_link: "https://gcuf.edu.pk/",
    },
    {
      title: "Board of Intermediate and Secondary Education, Faisalabad",
      subtitle: "Intermediate of Computer Science",
      logo_path: "sal.png",
      alt_name: "ics",
      duration: "2014 - 2016",
      descriptions: [
        "⚡ 2014-2016 I have done ICS (Intermediate of Computer Science) from this College",
        "⚡ I have obtained Marks (653) from total Marks (1100) and got 2nd Division.",
        "⚡ I have studied core subjects like Computer Science, Math, Statistics , etc.",
        "⚡ The intermediate of Computer Science (ICS) programme is a collective study of computer and",
        "⚡ Science to provide a general education in information technology and software development. ",
      ],
      website_link: "http://www.bisefsd.edu.pk/",
    },
    // {
    //   title: "S.M.I.T (Saylani Mass I.T Training)",
    //   subtitle: "Modern Application and API Development",
    //   logo_path: "smit.png",
    //   alt_name: "smit",
    //   duration: "2022 - 2023",
    //   descriptions: [
    //     "⚡ I completed the 'Modern Application and API Development' course from April 2022 to August 2023",
    //     "⚡ I have studied the following modules",
    //     "⚡ Module I: HTML5, CSS3, Bootstrap, Material-UI , Chakra-UI & Advanced JavaScript & TypeScript & Git",
    //     "⚡ Module II:  React JS, Next JS,  Redux, Redux-ToolKit, Context-APi, PWA, Gatsby, and Storybook",
    //     "⚡ Module III: API Economy and Cloud Development",
    //     "⚡ Module IV: Android & iOS Hybrid Mobile Apps, UI/UX Design, Design Patterns, and Innovation for Startups",
    //   ],
    //   website_link:
    //     "https://saylaniwelfareusa.com/en/services/education/technical-education/saylani-mass-it-training",
    // },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Certifed Computer Operator",
      subtitle: "Education Department of SMIT",
      logo_path: "smit.png",
      certificate_link:
        "https://drive.google.com/file/d/1oiuV8ko_63X679XKoN7w1Aav6Txf9jot/view",
      alt_name: "smit",
      color_code: "#ffc475",
    },
    {
      title: "Cisco Certified Network Associate",
      subtitle: "Education Department of SMIT",
      logo_path: "smit.png",
      certificate_link:
        "https://drive.google.com/file/d/1OzGGd1yIWpJP5mDCSh9meIfGwty8EYmr/view",
      alt_name: "smit",
      // color_code: "#ffc475",
      color_code: "#29AEEC",
    },
    {
      title: "Cisco IT Essentials",
      subtitle: "Cisco Networking Academy",
      logo_path: "cisco.png",
      certificate_link:
        "https://drive.google.com/file/d/1B2bZR_x20ux64jvuBBhOBwdBIRQGQhon/view",
      alt_name: "cisco",
      // color_code: "#ffc475",
      color_code: "#C5E2EE",
    },
    {
      title: "Certified Computer Operator",
      subtitle: "Education Department of SMIT",
      // logo_path: "viftech.jpg",
      logo_path: "vifr.png",
      certificate_link:
        "https://drive.google.com/file/d/1Ls1o-7Gb0bkAk4Z_qbfMMktaRMnBypQJ/view",
      alt_name: "smit",
      color_code: "#314A84",
    },
    {
      title: "MS Office & Computer Application",
      subtitle: "SMIT Register with TEVTA",
      // logo_path: "simt.png",
      logo_path: "simts.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1asSCOhgWTAL22t5YrMKsCLAfctMw0q4j/view",
      alt_name: "smit",
      color_code: "#3C92C5",

      // color_code: "#ffc475",
    },
    {
      title: "BASIC LIFE SUPPORT",
      subtitle: "Punjab Emergency Service Rescue 1122",
      logo_path: "rescue.png",
      certificate_link:
        "https://drive.google.com/file/d/15qyMuuOu_DYP6r0O0x0INGtWbEecetEE/view",
      alt_name: "Basic",
      color_code: "#469F47",
      // color_code: "#469F47",
    },
    {
      title: "Certificate of College Participant",
      subtitle: "Govt Municipal Graduate College",
      logo_path: "md.png",
      certificate_link:
        "https://drive.google.com/file/d/1gli1FLY0-ScOZ5GFfRuSHL8AxOShf-sQ/view",
      alt_name: "MD",
      color_code: "#FEFAF2",
      // color_code: "#ffc475",
    },
    {
      title: "Cyber Security",
      subtitle: "Education Department of SMIT",
      logo_path: "smit.png",
      certificate_link:
        "https://drive.google.com/file/d/11vMDqKkUDT5Y2F1OayW2GrTHhzOsoNAC/view?usp=sharing",
      alt_name: "smit",
      color_code: "#ffc475",
    },
    // {
    //   title: "Cyber Security",
    //   subtitle: "Education Department of SMIT",
    //   logo_path: "smit.png",
    //   certificate_link: "https://drive.google.com/file/d/11vMDqKkUDT5Y2F1OayW2GrTHhzOsoNAC/view?usp=sharing",
    //   alt_name: "smit",
    //   color_code: "#ffc475",
    // },
    // {
    //   title: "Cyber Security",
    //   subtitle: "2014-2017",
    //   logo_path: "google_logo.png",
    //   certificate_link: "https://drive.google.com/file/d/11vMDqKkUDT5Y2F1OayW2GrTHhzOsoNAC/view?usp=sharing",
    //   alt_name: "Google",
    //   color_code: "#1e70c1",
    // },
    // {
    //   title: "Google Summer of Code Mentor",
    //   subtitle: "2017 / 2018 / 2020",
    //   logo_path: "google_logo.png",
    //   certificate_link: " ",
    //   alt_name: "Google",
    //   color_code: "#ffbfae",
    // },
    // {
    //   title: "Google Code-In Mentor",
    //   subtitle: "2017 / 2018 / 2019",
    //   logo_path: "google_logo.png",
    //   certificate_link: " ",
    //   alt_name: "Google",
    //   color_code: "#b190b0",
    // },
    // {
    //   title: "Deep Learning Specialization",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://coursera.org/share/737a9587023c666b8e6cb303157aaeba",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#47A048",
    // },
    // {
    //   title: "Sequence Models",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/FM5AKEZA9NUY",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#F6B808",
    // },
    // {
    //   title: "Convolutional Neural Networks",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/U8BLDNUT9UUM",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#2AAFED",
    // },
    // {
    //   title: "Structuring Machine Learning Projects",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/YLC25SJQKH3Y",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#E2405F",
    // },
    // {
    //   title: "Machine Learning",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "stanford_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/records/72KY93DT82MP",
    //   alt_name: "Stanford University",
    //   color_code: "#8C151599",
    // },
    // {
    //   title: "Neural Networks and Deep Learning",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/records/25JXRB2RWHRX",
    //   alt_name: "Google",
    //   color_code: "#7A7A7A",
    // },
    // {
    //   title: "Improving Deep Neural Networks",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/records/PKR9M9LQ3JWC",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "Android Developer Nanodegree",
    //   subtitle: "Part of Google India Scholarship Program",
    //   logo_path: "100.png",
    //   certificate_link: "https://graduation.udacity.com/confirm/HLE7K5V3",
    //   alt_name: "Google",
    //   color_code: "#C5E2EE",
    // },
    // {
    //   title: "InOut 4.0 Winner #2",
    //   subtitle: "2017",
    //   logo_path: "ino.png",
    //   certificate_link: " ",
    //   alt_name: "InOut",
    //   color_code: "#fffbf3",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Internship",
  description:
    "During my career, I've successfully completed two internships. In my first internship, I gained experience as a frontend intern at Gamica Cloud for a duration of four months. In the second internship, I worked as a MERN stack developer at Devstrings Software House for three months.",
  subtitle1: "Work",
  // subtitle1: "Work, Internship",
  description1:
    "I have been working as a Associate Software Engineer in the MERN stack developer role at Bloctech Solutions since February 2023, and I am still currently employed in this position.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "MERN Stack Developer",
          company: "BlocTech Solutions",
          company_url: "https://www.canada.ca/en/revenue-agency.html",
          logo_path: "bloctech3.jpg",
          // logo_path: "bloctech1.png",
          // logo_path: "cra.png",
          duration: "February 2023 - Ongoing",
          location: "Faisalabad, Punjab Pakistan ",
          description:
            // "Canada Revenue Agency (CRA) administers tax laws for the Government of Canada and for most provinces and territories, and administers various social and economic benefit and incentive programs delivered through the tax system.",
            "I am Saqib Ali, a MERN Stack Developer, and I specialize in crafting robust web applications. My expertise includes utilizing technologies such as React.js, Next.js, JavaScript, TypeScript, and designing responsive frontends with MUI, Bootstrap, Chakra UI, and CSS3. On the backend, I employ Node.js, Express.js, MongoDB, Firebase, and Socket.IO for seamless data storage, retrieval, and real-time communication. I excel in using MongoDB and Firebase for data management, Node.js and Express.js for efficient routing, and React & Next.js for creating intuitive user interfaces. Furthermore, I have a deep understanding of React.js, a powerful JavaScript library for constructing dynamic and reusable UI components.",

          color: "#f10000",
        },
        // {
        //   title: "Full Stack Developer",
        //   company: "Quicko",
        //   company_url: "https://quicko.com/",
        //   logo_path: "quicko.jpg",
        //   duration: "June 2021 - October 2021",
        //   location: "Ahmedabad",
        //   description:
        //     "Quicko is an online tax planning, preparation & filing platform for individuals & businesses.",
        //   color: "#2962FF",
        // },
      ],
    },
    {
      title: "Internship One",
      experiences: [
        {
          title: "Front-End Developer",
          company: "Gamicacloud",
          company_url: "https://www.gamicacloud.com/",
          logo_path: "ga.png",
          duration: "March 2022 - August 2022",
          location: "Faisalabad, Punjab Pakistan",
          // location: "On-Site Work",
          // location: "Work From Home",
          description:
            "I did a Six-month internship as a Front End Developer, where I got really good at creating strong web applications. I used tools like React.js, Next.js, JavaScript, and TypeScript. I also learned how to design responsive frontends using things like MUI, Bootstrap, Chakra UI, and CSS3. This internship helped me improve my skills a lot!",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Internship Two",
      experiences: [
        {
          title: "MERN Stack Developer",
          company: "DevStrings",
          company_url: "https://devstrings.com/home",
          logo_path: "devStrigs.png",
          duration: "September 2022 to December 2022",
          location: "Faisalabad, Punjab Pakistan",
          description:
            "I completed an internship focused on the MERN stack, where I gained hands-on experience in developing full-stack web applications. During this internship, I honed my skills in utilizing MongoDB for efficient data management, implementing server-side logic with Node.js and Express.js, and creating dynamic and interactive user interfaces using React.js and Next.js. I also worked with various front-end frameworks such as MUI, Bootstrap, and Chakra UI, ensuring responsive and visually appealing designs. Additionally, I integrated real-time communication features using Socket.IO. Overall, this internship provided me with a comprehensive understanding of the MERN stack and its application in building modern web solutions.",
          color: "#4285F4",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    " I'm skilled at using a variety of the latest tech tools for my projects. I specialize in creating dynamic interfaces with React.js and Next.js, managing state with Redux, Redux Toolkit, and the Context API. I design responsive layouts using Material-UI and Bootstrap. For security, I use JWT tokens and Passport for authentication. Firebase and MongoDB handle data storage. This tech mix powers my projects, including e-commerce, social apps, and a Figma website. Note that not all these projects are on GitHub yet.",
  // "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "Saqib.png",
    description:
      "You can contact me using the information provided below. I'll do my best to respond to you as quickly as possible.",
    // "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Saqib Ali",
    subtitle:
      "I want to use what I'm good at to help a company succeed. I'm qualified and dedicated, and I'm excited about making the organization's future even better.",

    link: "https://linkedin.com/in/saqib-ali-873803229/",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      name: "E-Commerce ( MERN  Stack )",
      url: "https://github.com/SaqibAli01/Mern-Stack-E-Ecommerce",
      // description: "I successfully finished an E-Commerce Project using the MERN stack.",
      description:
        "I successfully completed an E-Commerce Project using the MERN stack with JWT token Authentication.",

      languages: [
        {
          name: "Material-UI",
          iconifyClass: "devicon-materialui",
        },
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Redux",
          iconifyClass: "devicon-redux",
        },
        // {
        //   name: "TypeScript",
        //   iconifyClass: "devicon-typescript",
        // },
        {
          name: "Node.js",
          iconifyClass: "devicon-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "devicon-express",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
    {
      name: "Social Media App ( MERN  Stack )",
      url: "https://github.com/SaqibAli01/Social-Media-App.git",
      description:
        "I made a social media app with posts (images, files, videos), comments, shares, likes, groups, and authentication. Used Redux Toolkit for asynchronous operations.",
      // "I developed a social media app with features like post creation (images, files, videos), commenting, sharing, liking, creating groups, and authentication.",

      languages: [
        {
          name: "Material-UI",
          iconifyClass: "devicon-materialui",
        },
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Redux ToolKit",
          iconifyClass: "devicon-redux",
        },
        // {
        //   name: "TypeScript",
        //   iconifyClass: "devicon-typescript",
        // },
        {
          name: "Node.js",
          iconifyClass: "devicon-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "devicon-express",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
      ],
      // "I have successfully created a social media app with features such as creating posts (including images, files, and videos), managing post creation, updates, and deletions, commenting, sharing, liking, and creating groups.",
      // "You personal journaling companion, goals & daily challenges! About 5k+ downloads on Play Store.",
      // languages: [
      //   {
      //     name: "Flutter",
      //     iconifyClass: "logos-flutter",
      //   },
      //   {
      //     name: "Firebase",
      //     iconifyClass: "logos-firebase",
      //   },
      // ],
    },
    {
      name: "Fashions E-Commerce-Store",
      url: "https://github.com/SaqibAli01/Fashions-eCommerce-Store.git",
      description:
        "I successfully completed an Fashion E-Commerce Project using the MERN stack with JWT token Authentication.",
      languages: [
        {
          name: "Material-UI",
          iconifyClass: "devicon-materialui",
        },
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Redux",
          iconifyClass: "devicon-redux",
        },
        // {
        //   name: "TypeScript",
        //   iconifyClass: "devicon-typescript",
        // },
        {
          name: "Node.js",
          iconifyClass: "devicon-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "devicon-express",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
      ],
      // languages: [
      //   {
      //     name: "NodeJS",
      //     iconifyClass: "logos-nodejs",
      //   },
      //   {
      //     name: "JavaScript",
      //     iconifyClass: "logos-javascript",
      //   },
      // ],
    },
    {
      name: "Stack Overflow Clone",
      url: "https://github.com/SaqibAli01/Stack-OverFlow.git",
      description:
        "I successfully completed an Stack Overflow Clone  using the MERN stack with passport js Authentication.",
      languages: [
        {
          name: "Material-UI",
          iconifyClass: "devicon-materialui",
        },
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Redux",
          iconifyClass: "devicon-redux",
        },
        // {
        //   name: "TypeScript",
        //   iconifyClass: "devicon-typescript",
        // },
        {
          name: "Node.js",
          iconifyClass: "devicon-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "devicon-express",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
    {
      name: "Quiz App  ( MERN Stack ) ",
      url: "https://github.com/SaqibAli01/Mern-Stack-Quiz-App.git",
      description: "I successfully completed a Quiz App.",
      languages: [
        {
          name: "CSS3",
          iconifyClass: "devicon-css3",
        },
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        // {
        //   name: "Redux",
        //   iconifyClass: "devicon-redux",
        // },
        // {
        //   name: "TypeScript",
        //   iconifyClass: "devicon-typescript",
        // },
        {
          name: "Node.js",
          iconifyClass: "devicon-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "devicon-express",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
    {
      name: "Expensive Tracker",
      url: "http://abstracted-orange.surge.sh/",
      description:
        "I finished a front-end project using React JS and the Context API called Expense Tracker.",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        //   {
        //   name: "JavaScript",
        //   iconifyClass: "logos-javascript",
        // },
        {
          name: "CSS3",
          iconifyClass: "devicon-css3",
        },
      ],
    },
    {
      name: "My Todo App",
      url: "https://careful-todo-app.surge.sh/",
      description:
        "I successfully finished 70% a front-end project called 'My Todo App' using React JS with local storage.",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "CSS3",
          iconifyClass: "devicon-css3",
        },
        // {
        //   name: "Python",
        //   iconifyClass: "logos-python",
        // },
        // {
        /* The above code is a comment in JavaScript. It is not doing anything in terms of
        functionality, but it is providing information or notes about the code. */
        //   name: "Firebase",
        //   iconifyClass: "logos-firebase",
        // }, //   name: "Firebase",
        //   iconifyClass: "logos-firebase",
        // },
      ],
    },
    {
      name: "Shoes Store",
      url: "https://obedient-shoes-store.surge.sh/",
      description:
        "I finished a front-end project using React JS and the Context API called Shoes Store.",
      languages: [
        {
          name: "Material-UI",
          iconifyClass: "devicon-materialui",
        },
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      name: "Redux Toolkit Shoping Store",
      url: "https://excited-onlineshoping.surge.sh/",
      description:
        "I successfully completed a front-end project named 'Redux Toolkit Shoping Store' using React JS, Redux Toolkit, and Bootstrap.",
      languages: [
        {
          name: "Redux Toolkit",
          iconifyClass: "logos-redux",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "bootstrap",
          iconifyClass: "logos-bootstrap",
        },
      ],
    },
    {
      name: "E-Stitch Website",
      url: "http://tidy-e-stitch.surge.sh/",
      description:
        "I successfully completed a front-end project named 'E-Stitch Website' using React JS, Redux, and Bootstrap.",
      languages: [
        {
          name: "Redux Toolkit",
          iconifyClass: "logos-redux",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "bootstrap",
          iconifyClass: "logos-bootstrap",
        },
      ],
    },
    {
      name: "NextJS Website Figma",
      url: "https://assignmentone-olive.vercel.app/",
      description:
        "I successfully completed a front-end project named 'Figma Website' using Next.js.",
      languages: [
        {
          name: "Nextjs",
          iconifyClass: "logos-nextjs",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos-bootstrap",
        },
      ],
    },
    {
      name: "Calculator",
      url: "https://starlit-dodol-2242fe.netlify.app/",
      description:
        "I successfully developed a calculator, implementing logic, alongside completing a front-end project named 'Calculator'  React.js.",

      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "Material-UI",
          iconifyClass: "devicon-materialui",
        },
      ],
    },
    {
      name: "Expensive Tracker",
      url: "http://abstracted-orange.surge.sh/",
      description:
        "I finished a front-end project using React JS and the Redux called Expense Tracker.",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Redux",
          iconifyClass: "logos-redux",
        },
        {
          name: "CSS3",
          iconifyClass: "devicon-css3",
        },
      ],
    },
    {
      name: "Audio Play List",
      url: "https://saqib-ali-audioplaylist.netlify.app/",
      description:
        "I successfully completed a front-end project for an audio playlist using React.js, Redux Toolkit, and MUI.",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Redux",
          iconifyClass: "logos-redux",
        },
        {
          name: "Material-UI",
          iconifyClass: "devicon-materialui",
        },
      ],
    },
    {
      name: "Event Planner",
      url: "https://event-planner-01.netlify.app/",
      description:
        "I successfully completed a project using React.js, MUI, Redux Toolkit with asynchronous thunk, and Firebase.",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Redux",
          iconifyClass: "logos-redux",
        },
        {
          name: "Material-UI",
          iconifyClass: "devicon-materialui",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    {
      name: "Stop Watch",
      url: "https://warlike-stopwatch.surge.sh/",
      description:
        "I have completed a front-end project using JavaScript and HTML5 & CSS3.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "devicon-html5",
        },
        {
          name: "CSS3",
          iconifyClass: "devicon-css3",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      name: "Fruits Bills",
      url: "https://untidy-fruits.surge.sh/",
      description:
        "I have completed a front-end project using JavaScript and HTML5 & CSS3.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "devicon-html5",
        },
        {
          name: "CSS3",
          iconifyClass: "devicon-css3",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      name: "Calculator",
      url: "https://hushed-calculator.surge.sh/",
      description:
        "I have completed a front-end project using JavaScript and HTML5 & CSS3.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "devicon-html5",
        },
        {
          name: "CSS3",
          iconifyClass: "devicon-css3",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      name: "Bubble Game",
      url: "https://standing-bubblgames.surge.sh/",
      description:
        "I have completed a front-end project using JavaScript and HTML5 & CSS3.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "devicon-html5",
        },
        {
          name: "CSS3",
          iconifyClass: "devicon-css3",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      name: "Chat App",
      url: "https://best-chat.surge.sh/",
      description:
        "I have completed a front-end project using JavaScript and HTML5 & CSS3.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "devicon-html5",
        },
        {
          name: "CSS3",
          iconifyClass: "devicon-css3",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      name: "Balloons Game",
      url: "https://youthful-baloongame.surge.sh/",
      description:
        "I have completed a front-end project using JavaScript and HTML5 & CSS3.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "devicon-html5",
        },
        {
          name: "CSS3",
          iconifyClass: "devicon-css3",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      name: "Spaceships Game",
      url: "https://righteous-game.surge.sh/",
      description:
        "I have completed a front-end project using JavaScript and HTML5 & CSS3.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "devicon-html5",
        },
        {
          name: "CSS3",
          iconifyClass: "devicon-css3",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    // {
    //   name: "Object + Face Detection",
    //   url: " ",
    //   description: "2017 project. Object detection + accurate face detection.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Tensorflow",
    //       iconifyClass: "logos-tensorflow",
    //     },
    //     {
    //       name: "OpenCV",
    //       iconifyClass: "logos-opencv",
    //     },
    //   ],
    // },
    // {
    //   name: "Image Captioning with Visual Attention",
    //   url: " ",
    //   description: "Ongoing. Used MSCOCO 2014/2017 for image captioning.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Tensorflow",
    //       iconifyClass: "logos-tensorflow",
    //     },
    //     {
    //       name: "Jupyter Notebook",
    //       iconifyClass: "logos-jupyter",
    //     },
    //   ],
    // },
    // {
    //   name: "DalSocial",
    //   url: " ",
    //   description:
    //     "An Android app to meet new people in the university, organize and join events. ",
    //   languages: [
    //     {
    //       name: "Kotlin",
    //       iconifyClass: "simple-icons:kotlin",
    //       color: "#F18E33",
    //     },
    //     {
    //       name: "Android",
    //       iconifyClass: "simple-icons:android",
    //       color: "#3DDC84",
    //     },
    //     {
    //       name: "Firebase",
    //       iconifyClass: "logos-firebase",
    //     },
    //   ],
    // },
    // {
    //   name: "HalifaxFoodie",
    //   url: " ",
    //   description:
    //     "CSCI5410 Project. A multi-client recipe app for Halifax Foodies.",
    //   languages: [
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "AWS",
    //       iconifyClass: "logos-aws",
    //     },
    //     {
    //       name: "Google Cloud",
    //       iconifyClass: "logos-google-cloud",
    //     },
    //   ],
    // },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
